import React from 'react'
import PropTypes from 'prop-types';
import { Nav, NavItem } from 'react-bootstrap'
import { Route, Switch } from 'react-router-dom'
import RouteMatcher from '~/RouteMatcher'

import ScriptInfoScreen from './ScriptInfoScreen'
import ScriptCodeScreen from './ScriptCodeScreen'
import ScriptDeployedCodeScreen from './ScriptDeployedCodeScreen'
import ScriptLogsScreen from './ScriptLogsScreen'

import { View } from '~/views';

export default class ScriptHomeScreen extends React.Component {

  static routes = [
    <Route key="/project/:projectId/script/:scriptId" path="/project/:projectId/script/:scriptId" exact component={ScriptInfoScreen} />,
    <Route key="/project/:projectId/script/:scriptId/" path="/project/:projectId/script/:scriptId/" exact component={ScriptInfoScreen} />,
    <Route key="/project/:projectId/script/:scriptId/info" path="/project/:projectId/script/:scriptId/info" exact={false} component={ScriptInfoScreen} />,
    <Route key="/project/:projectId/script/:scriptId/code" path="/project/:projectId/script/:scriptId/code" exact={false} component={ScriptCodeScreen} />,
    <Route key="/project/:projectId/script/:scriptId/deployedCode" path="/project/:projectId/script/:scriptId/deployedCode" exact={false} component={ScriptDeployedCodeScreen} />,
    <Route key="/project/:projectId/script/:scriptId/logs" path="/project/:projectId/script/:scriptId/logs" exact={false} component={ScriptLogsScreen} />,
  ]

  constructor( props ) {
    super( props );

    this.routeMatcher = new RouteMatcher( ScriptHomeScreen.routes, { missComponent : null } )

  }

  onTabSelected = ( key, evt ) => {
    const { history, match } = this.props
    const { projectId, scriptId } = match.params
    history.push( `/project/${projectId}/script/${scriptId}/${key}` )
  }

  render() {
    const { location } = this.props

    const matchResult = this.routeMatcher.find( location )

    const keys = [ 'info', 'info', 'info', 'code', 'deployedCode', 'logs' ]
    const activeKey = keys[matchResult.matchIndex]

    return ( 
      <View style={{ display : 'flex', flexDirection : 'column', overflow : 'hidden' }}>
        <Nav bsStyle="tabs" activeKey={activeKey} onSelect={this.onTabSelected}>
          <NavItem eventKey="info">Info</NavItem>
          <NavItem eventKey="code">Code</NavItem>
          <NavItem eventKey="deployedCode">Deployed Code</NavItem>
          <NavItem eventKey="logs">Logs</NavItem>
        </Nav>

        <div style={{ flex : 1, overflow : 'auto', position : 'relative' }}>
          <Switch>
            {ScriptHomeScreen.routes}
          </Switch>
        </div>
      </View>
    )
  }
}
